import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import Select, { StylesConfig } from "react-select";
import { mapMstToOptions } from "utils/HelperFunction";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { login } from "../redux/handlers/auth/login.handler";
import { VER } from "constants/server/api";
import { LOGO_URL, SERVER_NAME } from "constants/server/config";
import { env } from "env";
import CheckIcon from "@mui/icons-material/Check";
import { clearRegisterVerify, registerVerify } from "../redux/handlers/auth/registerVerify.handler";
export function RegisterSuccess() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var registerVerifyReducer = useAppSelector(function(state) {
        return state.registerVerifyReducer;
    });
    var _useState = _sliced_to_array(useState(function() {
        var params = new URLSearchParams(window.location.search);
        return params.get("email") || "";
    }), 2), email = _useState[0], setEmail = _useState[1];
    var _useState1 = _sliced_to_array(useState(function() {
        var params = new URLSearchParams(window.location.search);
        return params.get("token") || "";
    }), 2), token = _useState1[0], setToken = _useState1[1];
    var handleRegisterVerify = function() {
        if (!email || email === "" || email === undefined || !token || token === "" | token === undefined) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "เกิดข้อผิดพลาด",
                navigateDirection: navigate("/login"),
                title: "กรุณาติดต่อเราเพื่อขอความช่วยเหลือ"
            }));
            return;
        }
        var data = {
            token: token,
            email: email
        };
        dispatch(registerVerify(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(registerVerifyReducer.isFetching);
        if (registerVerifyReducer.data && registerVerifyReducer.isError) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "เกิดข้อผิดพลาด",
                navigateDirection: navigate("/login"),
                title: registerVerifyReducer.data.message
            }));
            dispatch(clearRegisterVerify());
            return;
        }
        dispatch(clearRegisterVerify());
    }, [
        registerVerifyReducer
    ]);
    useEffect(function() {
        localStorage.clear();
        handleRegisterVerify();
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: "loginpage bg-white",
        children: /*#__PURE__*/ _jsx(Row, {
            className: "g-0",
            children: /*#__PURE__*/ _jsx(Col, {
                className: "d-flex justify-content-center align-items-center h-100vh",
                children: /*#__PURE__*/ _jsx(Card, {
                    className: "box-login",
                    style: {
                        maxWidth: "550px"
                    },
                    children: /*#__PURE__*/ _jsxs(Card.Body, {
                        className: "",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "d-flex justify-content-center align-items-center mb-3",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "p-3",
                                    style: {
                                        borderRadius: "100px",
                                        backgroundColor: "#2DC76D"
                                    },
                                    children: /*#__PURE__*/ _jsx(CheckIcon, {
                                        sx: {
                                            fontSize: 100,
                                            color: "#FFFFFF"
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-center fs-20 fw-500 tc-1",
                                children: "ขั้นตอนสุดท้าย"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-center fs-16 fw-500 tc-6",
                                children: "คุณได้ยืนยันที่อยู่อีเมลแล้วเพื่อให้บัญชีของคุณเสร็จสมบูรณ์"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-center fs-16 fw-500 mb-4 tc-6",
                                children: "โดยมีขั้นตอนง่ายๆโดยคลิกที่ปุ่มด้านล่าง"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-login w-100",
                                onClick: function() {
                                    return navigate("/login");
                                },
                                children: "เข้าสู่ระบบการใช้งาน"
                            })
                        ]
                    })
                })
            })
        })
    });
}
